import { useState } from 'react';
import { Modal } from '@clariness/modal';
import { Store } from 'store';
import { Button } from '@clariness/button';
import { Flex } from '@clariness/flex';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '@clariness/clarikit-react';
import { Checkbox } from '@clariness/checkbox';

type RequestMedicalRecordsConsentModalProps = {
  onConfirm: () => void;
};

export const RequestMedicalRecordsConsentModal = ({
  onConfirm,
}: RequestMedicalRecordsConsentModalProps) => {
  const { closeModal } = Store.useModal();
  const intl = useIntl();
  const [consentConfirmed, setConsentConfirmed] = useState(false);

  return (
    <Modal
      sx={{
        width: '460px',
      }}
      onClose={closeModal}
    >
      <Modal.Header
        title={intl.formatMessage({
          id: 'is.request_medical_records.consent_modal.title',
          defaultMessage: 'Consent',
        })}
        sx={{
          height: '74px',
        }}
      />
      <Modal.Body
        sx={{
          flexDirection: 'column',
          gap: '20px',
          pb: '35px',
        }}
      >
        <Text as="p">
          <FormattedMessage
            id="is.request_medical_records.consent_modal.description"
            defaultMessage="By proceeding with this request, you confirm that patient consent has been obtained."
          />
        </Text>

        <Flex
          sx={{
            alignItems: 'center',
          }}
        >
          <Checkbox
            checked={consentConfirmed}
            onChange={(event) => setConsentConfirmed(event.target.checked)}
            data-testid="request-medical-records-consent-checkbox"
            sx={{
              marginRight: '12px',
            }}
          />
          <Text as="span">
            <FormattedMessage
              id="is.request_medical_records.consent_modal.checkbox"
              defaultMessage="I received consent from patient"
            />
          </Text>
        </Flex>
      </Modal.Body>
      <Modal.Footer sx={{ borderTopStyle: 'none' }}>
        <Flex
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            size="medium"
            disabled={!consentConfirmed}
            onClick={() => {
              if (!consentConfirmed) {
                return;
              }
              closeModal();
              onConfirm();
            }}
          >
            <FormattedMessage
              id="is.request_medical_records.consent_modal.confirm"
              defaultMessage="Consent Received"
            />
          </Button>
          <Button
            variant="secondary"
            size="medium"
            sx={{
              marginLeft: '16px',
            }}
            onClick={closeModal}
          >
            <FormattedMessage
              id="is.request_medical_records.consent_modal.close"
              defaultMessage="Close"
            />
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
